import { render } from "./Computer.vue?vue&type=template&id=70433952&scoped=true"
import script from "./Computer.vue?vue&type=script&lang=js"
export * from "./Computer.vue?vue&type=script&lang=js"

import "./Computer.vue?vue&type=style&index=0&id=70433952&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70433952"]])

export default __exports__